<template>
<div class="custom-sort" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
        <label>{{sortlabel}} : </label> {{ selected }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
        <div v-for="(option, i) of options" :key="i" @click="
        selected = option.text;
      open = false;
      $emit('getInput', option.value);
      " :class="selected == option.text ? 'active' : ''">
            {{ option.text }}
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'customSorting',
    props: {
        options: {
            type: Array,
            required: true,
        },
        sortlabel: {
            type: String,
            required: false,
            default: null,
        },
        default: {
            type: String,
            required: false,
            default: null,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            selected: this.default ?
                this.default :
                this.options.length > 0 ?
                this.options[0] :
                null,
            open: false,
        };
    },
    computed: {
        selectText() {
            return this.default || this.options?.[0];
        }

    },
};
</script>

<style lang="scss" src="./custom-sorting.scss"></style>
